import { Box, Dialog, FormControl, FormControlLabel, IconButton, Radio, RadioGroup } from "@mui/material"
import React, { useContext, useState } from "react"
import CommonTypo from "../../components/CommonTypo"
import { pxToRem } from "../../theme/typography"
import NewButton from "../../components/NewButton"
import BellIcon from "../../assets/images/icon/BellIcon"
import ModalCloseIconWhite from "../../assets/images/icon/modalCloseIconWhite"
import { UserTypeContext } from "../../context/userStatus"
import { userService } from "../../services/auth"

const PaymentPlanInfo = ({
    visiblePaymentInfo,
    onClose,
    fixClosePopup = () => {},
    subscriptionPlanEnded = false,
    subscriptionPlanEndedBilling = false
}) => {
    const token = localStorage.getItem("userDetails")
    const [selectedPlan, setSelectedPlan] = useState(null)
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    console.log("IUserTypeState.planProducts", IUserTypeState.planProducts)
    const closeWithSelectedPlan = () => {
        if (subscriptionPlanEndedBilling) {
            getBillingPorta()
        } else {
            const foundPlan = IUserTypeState.planProducts.find(it => {
                return it.price.id === selectedPlan
            })
            if (foundPlan) {
                createCheckoutLink(foundPlan)
            }
        }

    }
    const getBillingPorta = () => {
        userService.billingPortal(token).then(data => {
            window.open(data.data.url)
        }).catch(err => {
            console.log("err", err);

        })
    }
    const createCheckoutLink = (planInfo) => {
        userService.createCheckout({
            price: planInfo.price.id
        }, token).then(data => {
            console.log("data", data)
            if (data.data) {
                window.open(data.data.url)
            }
        }).catch(err => {
            console.log("err", err);

        })
    }
    return <Dialog
        onClose={() => { }}
        open={visiblePaymentInfo}
        className={"dialogWrapper"}
        disableEscapeKeyDown
        sx={{
            "& .MuiDialog-paper": {
                display: 'flex !important',
                padding: '0px',
                flexDirection: 'column !important',
                alignItems: 'flex-start !important',
                gap: '24px !important',
                width: "628px",
                overflowY: "auto",
                position: "relative"
            }
        }}
        PaperProps={{
            className: "hide-scrollbar"
        }}
    >
        {subscriptionPlanEndedBilling && <IconButton
            onClick={fixClosePopup}
            sx={{
                position: "absolute",
                right: "12px",
                top: "10px",
                padding: 0
            }}
        >
            <ModalCloseIconWhite size="24"/>
        </IconButton>}
        <Box sx={{
            width: "100%",
            borderRadius: "12px 12px 0px 0px"
        }}>
            <img src={subscriptionPlanEnded ? "/paymentplanend.png" : "/paymentplanwelcome.png"} alt="payment-logo" style={{
                width: "100%",
                height: "314px",
                objectFit: "cover",
                borderRadius: "12px 12px 0px 0px",
                objectPosition: "center 75%"
            }} />
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"}>
            <CommonTypo size={24} lineHeight={24} color="var(--color-text-primary)" fontWeight={700}>{subscriptionPlanEnded ? "Trial ended": "Try 14 Days Free"}</CommonTypo>
            <CommonTypo size={16} lineHeight={24} color="var(--color-text-secondary)" fontWeight={400}>{subscriptionPlanEnded ? "We hope you had only good experience with our app. It’s time to get PRO and continue your journey" : "Effectively manage your progress and improve yourself. Get personalized data, insights, and recommendations to achieve goals"}</CommonTypo>
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"} sx={{
            marginTop: "24px"
        }}>
            <Box display={"flex"} flexDirection={"column"} gap={"48px"} padding={"0px"}>
                <PlanStepInfo icon={<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_3_374)">
                        <path d="M19.5 7.625H9.375V5.75C9.375 5.05381 9.65156 4.38613 10.1438 3.89384C10.6361 3.40156 11.3038 3.125 12 3.125C13.2666 3.125 14.4047 4.02688 14.6475 5.22406C14.6769 5.36884 14.7346 5.50641 14.8172 5.62892C14.8998 5.75142 15.0057 5.85645 15.1289 5.93802C15.252 6.01959 15.3901 6.0761 15.5351 6.10432C15.6801 6.13254 15.8293 6.13192 15.9741 6.1025C16.1188 6.07308 16.2564 6.01542 16.3789 5.93283C16.5014 5.85024 16.6065 5.74433 16.688 5.62115C16.7696 5.49797 16.8261 5.35992 16.8543 5.2149C16.8825 5.06988 16.8819 4.92072 16.8525 4.77594C16.3941 2.51562 14.3531 0.875 12 0.875C10.7075 0.876489 9.46842 1.39058 8.5545 2.3045C7.64058 3.21842 7.12649 4.45753 7.125 5.75V7.625H4.5C4.00272 7.625 3.52581 7.82254 3.17417 8.17417C2.82254 8.52581 2.625 9.00272 2.625 9.5V20C2.625 20.4973 2.82254 20.9742 3.17417 21.3258C3.52581 21.6775 4.00272 21.875 4.5 21.875H19.5C19.9973 21.875 20.4742 21.6775 20.8258 21.3258C21.1775 20.9742 21.375 20.4973 21.375 20V9.5C21.375 9.00272 21.1775 8.52581 20.8258 8.17417C20.4742 7.82254 19.9973 7.625 19.5 7.625ZM19.125 19.625H4.875V9.875H19.125V19.625ZM10.5 14.75C10.5 14.4533 10.588 14.1633 10.7528 13.9166C10.9176 13.67 11.1519 13.4777 11.426 13.3642C11.7001 13.2506 12.0017 13.2209 12.2926 13.2788C12.5836 13.3367 12.8509 13.4796 13.0607 13.6893C13.2704 13.8991 13.4133 14.1664 13.4712 14.4574C13.5291 14.7483 13.4994 15.0499 13.3858 15.324C13.2723 15.5981 13.08 15.8324 12.8334 15.9972C12.5867 16.162 12.2967 16.25 12 16.25C11.6022 16.25 11.2206 16.092 10.9393 15.8107C10.658 15.5294 10.5 15.1478 10.5 14.75Z" fill="#3E4240" />
                    </g>
                    <defs>
                        <clipPath id="clip0_3_374">
                            <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                    </defs>
                </svg>
                } title={subscriptionPlanEnded ? "14 days ago" : "Right now"} description="Get instant full access and see how TNT can improve your life. {#} We won’t charge you now." active step={1} />
                {/* <PlanStepInfo icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.1209 15.5559C20.3072 14.1562 19.875 12.1472 19.875 9.75C19.875 7.66142 19.0453 5.65838 17.5685 4.18153C16.0916 2.70469 14.0886 1.875 12 1.875C9.91142 1.875 7.90838 2.70469 6.43153 4.18153C4.95468 5.65838 4.125 7.66142 4.125 9.75C4.125 12.1481 3.69468 14.1562 2.88093 15.5559C2.71488 15.8414 2.62687 16.1656 2.62571 16.4958C2.62456 16.8261 2.71032 17.1509 2.87437 17.4375C3.03739 17.7243 3.27399 17.9624 3.55977 18.1272C3.84554 18.292 4.17012 18.3775 4.5 18.375H7.89187C7.9849 19.4003 8.45794 20.3537 9.21808 21.048C9.97822 21.7423 10.9705 22.1273 12 22.1273C13.0295 22.1273 14.0218 21.7423 14.7819 21.048C15.542 20.3537 16.0151 19.4003 16.1081 18.375H19.5C19.8294 18.377 20.1534 18.2913 20.4386 18.1265C20.7239 17.9617 20.96 17.7239 21.1228 17.4375C21.2876 17.1513 21.3741 16.8267 21.3738 16.4965C21.3735 16.1662 21.2863 15.8418 21.1209 15.5559ZM12 19.875C11.5678 19.8751 11.1488 19.7258 10.8139 19.4525C10.4791 19.1791 10.2489 18.7985 10.1625 18.375H13.8375C13.751 18.7985 13.5209 19.1791 13.1861 19.4525C12.8512 19.7258 12.4322 19.8751 12 19.875ZM5.12437 16.125C5.95406 14.4375 6.375 12.2944 6.375 9.75C6.375 8.25816 6.96763 6.82742 8.02252 5.77252C9.07741 4.71763 10.5082 4.125 12 4.125C13.4918 4.125 14.9226 4.71763 15.9775 5.77252C17.0324 6.82742 17.625 8.25816 17.625 9.75C17.625 12.2934 18.045 14.4375 18.8747 16.125H5.12437Z" fill="#656565" />
                </svg>
                } title="Day 12" description="We’ll remind you with a notification that your trial ends soon" step={2} /> */}
                <PlanStepInfo icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.7813 9C22.665 8.64123 22.4449 8.32501 22.1489 8.09137C21.8528 7.85773 21.4941 7.71718 21.1181 7.6875L15.8128 7.25906L13.7653 2.30812C13.6214 1.95821 13.3768 1.65895 13.0625 1.44836C12.7482 1.23776 12.3783 1.12532 12 1.12532C11.6217 1.12532 11.2519 1.23776 10.9375 1.44836C10.6232 1.65895 10.3786 1.95821 10.2347 2.30812L8.18907 7.26L2.88376 7.6875C2.50709 7.71856 2.14801 7.86026 1.85163 8.0948C1.55526 8.32933 1.33482 8.64623 1.21801 9.00567C1.1012 9.36511 1.09324 9.75106 1.19512 10.115C1.297 10.479 1.50418 10.8047 1.79063 11.0512L5.83876 14.5425L4.60126 19.7644C4.511 20.1325 4.53235 20.5192 4.66259 20.8752C4.79283 21.2312 5.02608 21.5404 5.33261 21.7634C5.63915 21.9864 6.00512 22.1131 6.38392 22.1274C6.76272 22.1417 7.1372 22.043 7.45969 21.8437L12 19.0491L16.5403 21.8437C16.8627 22.0416 17.2366 22.1394 17.6146 22.1247C17.9926 22.11 18.3577 21.9835 18.6638 21.7611C18.9699 21.5388 19.2031 21.2307 19.3339 20.8757C19.4647 20.5208 19.4873 20.135 19.3988 19.7672L18.1613 14.5453L22.2094 11.0541C22.4975 10.8069 22.7057 10.4797 22.8076 10.114C22.9094 9.74824 22.9002 9.36051 22.7813 9ZM16.1747 13.2844C16.0186 13.4189 15.9025 13.5938 15.839 13.7899C15.7755 13.986 15.7671 14.1957 15.8147 14.3962L17.0231 19.5L12.5897 16.7737C12.4124 16.6646 12.2082 16.6068 12 16.6068C11.7918 16.6068 11.5876 16.6646 11.4103 16.7737L6.97688 19.5L8.18532 14.4C8.23292 14.1995 8.22451 13.9897 8.16103 13.7936C8.09754 13.5976 7.98141 13.4227 7.82532 13.2881L3.86251 9.86625L9.05626 9.44719C9.26294 9.43058 9.46101 9.35718 9.6286 9.23508C9.79619 9.11299 9.92678 8.94695 10.0059 8.75531L12 3.92719L13.9941 8.75531C14.0732 8.94695 14.2038 9.11299 14.3714 9.23508C14.539 9.35718 14.7371 9.43058 14.9438 9.44719L20.1375 9.86625L16.1747 13.2844Z" fill="#656565" />
                </svg>
                } title={subscriptionPlanEnded ? "Today" : "Day 15"} description="Start your subsciption, after you enter credit card info" step={3} active={subscriptionPlanEnded} />
            </Box>
        </Box>
        {subscriptionPlanEnded && !subscriptionPlanEndedBilling && (
            <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"} sx={{
                marginTop: "24px",
                width: "100%",
            }}>
                <FormControl sx={true ? {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    alignSelf: 'stretch',
                    justifyContent: "center",
                    width: "100%",
                } : {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '8px',
                    alignSelf: 'stretch',
                }}>
                    {<RadioGroup
                        className="radio-wrapper"
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        onChange={(e) => setSelectedPlan(e.target.value)}
                        value={selectedPlan || ""}
                        sx={true ? {
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '8px',
                            alignSelf: 'stretch',
                            padding: "0px",
                            width: "100%",
                            marginBottom: 0
                        } : {
                            width: "100%",
                            marginBottom: 0
                        }}
                    >
                        {IUserTypeState.planProducts.map(({ name, price: { id, currency, unit_amount } }) => {
                            return <FormControlLabel value={id} control={<Radio sx={{
                                "&.MuiRadio-root.Mui-checked": {
                                    color: "var(--color-text-primary)"
                                },
                                "&.MuiRadio-root": {
                                    padding: "0px"
                                }
                            }} />} label={name} sx={{
                                display: 'flex',
                                padding: '0px',
                                alignItems: 'center',
                                gap: '12px',
                                flex: '1 0 0',
                                borderRadius: '12px',
                                border: 'none',
                                background: '#FFF',
                                marginRight: 0,
                                marginLeft: 0,
                                "& .MuiTypography-root": {
                                    color: "var(--color-text-primary) !important",
                                    fontSize: "16px !important",
                                    lineHeight: `25.6px !important`,
                                    "@media  (max-width: 726px)": {
                                        fontSize: `16px !important`,
                                        lineHeight: `25.6px !important`,
                                    }
                                }
                            }} />
                        })}


                    </RadioGroup>}
                </FormControl>
            </Box>
        )}

        <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={"0px 32px"} sx={{
            marginTop: "24px",
            width: "100%",
            marginBottom: "24px"
        }}>
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                <NewButton
                    type="button"
                    isDisabled={false}
                    boxSx={{
                        display: 'flex',
                        alignSelf: "stretch",
                        width: "312px",
                        justifyContent: "center",
                    }}
                    extraSx={{
                        display: 'flex',
                        alignSelf: "stretch",
                        width: "312px",
                        background: "var(--color-new-main)",
                        height: "40px",
                        "&:hover": {
                            background: "var(--color-new-main)",
                        }
                    }}
                    typographySx={{
                        "&.MuiTypography-root": {
                            fontSize: `${pxToRem(16)} !important`,
                            lineHeight: "100% !important",
                            fontWeight: 600,
                            color: "var(--color-text-primary)",
                            "@media  (max-width: 786px) and (min-width: 100px)": {
                                fontSize: `${pxToRem(16)} !important`,
                                lineHeight: "100% !important",
                                fontWeight: 600,
                                color: "var(--color-text-primary)"
                            },
                        },
                    }}
                    buttonText={<Box display={"flex"} alignItems={"center"} gap={"4px"}>
                        <CommonTypo color="var(--color-text-primary)" fontWeight={600} size={16} lineHeight={16}>{subscriptionPlanEnded ? subscriptionPlanEndedBilling ?  "Manage subscription" : "Subscribe" : "Awesome"}</CommonTypo>
                    </Box>}
                    onClick={subscriptionPlanEnded ? closeWithSelectedPlan : onClose}
                    fontSize="18px"
                // isLoadong={showLoader}
                />
            </Box>
            <CommonTypo size={16} lineHeight={24} color="var(--color-text-secondary)" fontWeight={400} extraSx={{
                textAlign: "center",
                width: "100%"
            }}>14 days free, then $9.99/month</CommonTypo>
        </Box>
    </Dialog>
}

export default PaymentPlanInfo

const PlanStepInfo = ({
    icon = null,
    title = "",
    description = "",
    active = false,
    step = 1
}) => {
    return <Box display={"flex"} gap={"8px"} alignItems={"center"} >
        <Box display={"flex"} gap={"8px"} alignItems={"center"} justifyContent={"center"} sx={{
            width: "48px",
            height: "48px",
            padding: "0px",
            gap: "8px",
            borderRadius: "100%",
            background: active ? "var(--color-new-main)" : "var(--color-border)",
            border: "4px solid var(--white-background)",
            position: "relative",
            "&:before": step === 1 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 30,
                backgroundColor: active ? "var(--color-new-main)" : "var(--color-border)",
                transform: "translateY(-32px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : step === 2 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 60,
                backgroundColor: active ? "var(--color-new-main)" : "var(--color-border)",
                transform: "translateY(-60px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : step === 3 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 95,
                backgroundColor: active ? "var(--color-new-main)" : "var(--color-border)",
                transform: "translateY(-60px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : {},
            "&:after": step === 3 ? {
                content: '""',
                display: "flex",
                position: "absolute",
                top: 0, // Adjust to properly align
                width: 8,
                height: 30,
                backgroundColor:  "var(--color-border)",
                transform: "translateY(40px) rotate(0deg)",
                zIndex: 0,
                borderRadius: "8px"
            } : {}
        }}>
            <Box display={"flex"} gap={"8px"} alignItems={"center"} justifyContent={"center"} sx={{
                width: "48px",
                height: "48px",
                padding: "8px",
                gap: "8px",
                borderRadius: "100%",
                background: active ? "var(--color-new-main)" : "var(--color-border)",
                border: "4px solid var(--white-background)",
                zIndex: 1
            }}>
                {icon}
            </Box>
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"4px"}>
            <CommonTypo size={14} fontWeight={700} lineHeight={14} color="var(--color-text-primary)">{title}</CommonTypo>
            {description.split("{#}").map(it => <CommonTypo size={14} fontWeight={400} lineHeight={14} color="var(--color-text-secondary)" key={it.trim()}>{it.trim()}</CommonTypo>)}
        </Box>
    </Box>
}